// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__VEiFh","item":"Breadcrumbs_item__l2zge"};